import CityPageTemplate from "../city-template/CityPageTemplate";
import { superiorConfig } from "./data";

export default function SuperiorPage() {
  return <CityPageTemplate config={superiorConfig} />;
}